import type { PageHelp } from '../network-help.data';

export const L10N_ar_g1: Record<string, PageHelp> = {
  customers: {
    title: 'العملاء',
    tag: 'دليل إدارة علاقات العملاء',
    tagline: 'السجل الرئيسي للمسافرين والشركات الذين تبيع لهم الوكالة.',
    business: {
      lead: 'العملاء هم من تبيع لهم الوكالة فعلياً — المسافرون للترفيه والحسابات المؤسسية والمرافقون الذين يسافرون معهم. الاحتفاظ بسجل واحد نظيف لكل عميل هو ما يتيح للمنصة تعبئة الحجوزات مسبقاً، وتسعير شريحة بشكل مختلف، وتشغيل نادي ولاء، وفوترة الطرف الصحيح. العميل القابل للفوترة يصبح أيضاً طرف حساب في المحاسبة لاحقاً.',
      points: [
        { title: 'مصدر واحد للحقيقة', desc: 'الاسم والوثيقة وبيانات الاتصال والموافقة تعيش على سجل العميل — شاشات الحجز تقرأ منه، لذا يُدخل المسافر مرة واحدة ويُعاد استخدامه في كل مكان.' },
        { title: 'الشرائح تحرّك السعر', desc: 'يمكن أن ينتمي العميل إلى مجموعة عملاء؛ عندها تستطيع طبقة Retail في التسعير والقواعد تسعير تلك المجموعة بشكل مختلف — خصم لكبار العملاء، ورسم للعملاء العابرين.' },
        { title: 'تُسجَّل الموافقة', desc: 'موافقة التسويق وموافقة معالجة البيانات تُخزَّن لكل عميل حتى يبقى التواصل متوافقاً مع الأنظمة.' },
      ],
    },
    software: {
      lead: 'قائمة قابلة للبحث لكل عميل، مع أعمدة الاتصال والولاء والموافقة التي تحتاجها لإدارتهم.',
      points: [
        { title: 'ابحث وصفِّ', desc: 'ابحث بالاسم أو الهاتف أو البريد الإلكتروني أو رقم الهوية الوطنية؛ افتح صفاً لعرض الملف الكامل.' },
        { title: 'حرّر الملف', desc: 'يلتقط درج التحرير الهوية والهاتف/الواتساب (مفتاح الاتصال والرقم منفصلين) والجنسية والقناة واللغة المفضلة ومستوى كبار العملاء والملاحظات الداخلية؛ أضف المرافقين الذين يسافرون معهم.' },
        { title: 'الولاء بلمحة', desc: 'يعرض كل ملف رصيد نقاط العميل ومستواه وسجله، مع كسب/استبدال/تعديل يدوي.' },
      ],
    },
    related: ['customer-groups', 'loyalty', 'markup', 'agencies'],
  },

  'customer-groups': {
    title: 'مجموعات العملاء',
    tag: 'التقسيم إلى شرائح',
    tagline: 'وسم العملاء ضمن شرائح لتتمكن طبقة تسعير Retail من معاملتهم بشكل مختلف.',
    business: {
      lead: 'مجموعة العملاء هي شريحة مُسمّاة — «كبار العملاء»، «مؤسسي — Acme»، «العملاء العابرون» — يمكنك التسعير بناءً عليها. إنها النظير من جانب العميل لمجموعة الوكالات: حيث تحدد مجموعات الوكالات نطاق قواعد Wholesale/Distribution، تحدد مجموعات العملاء نطاق طبقة Retail، حتى تستطيع الوكالة البائعة مكافأة شريحة من عملائها أو فرض رسم إضافي عليها.',
      points: [
        { title: 'رافعة لهامش التجزئة', desc: 'عضوية المجموعة هي ما تستهدفه قاعدة Retail — مثل خصم ولاء −3% لمجموعة كبار العملاء، أو رسم خدمة للعملاء العابرين غير المتحقق منهم.' },
        { title: 'عضوية لا تسلسل هرمي', desc: 'ينتمي العميل ببساطة إلى مجموعة؛ لا يوجد تداخل. وسم واحد واضح يبقي التسعير قابلاً للتوقع.' },
        { title: 'مملوكة للوكالة', desc: 'تحدد كل وكالة مجموعاتها الخاصة على عملائها الخاصين — لا تتسرب عبر الشبكة.' },
      ],
    },
    software: {
      lead: 'أنشئ المجموعات وعيّن العملاء، ثم أشِر إلى المجموعة من نطاق Group لقاعدة تسعير Retail.',
      points: [
        { title: 'أنشئ المجموعة وسمِّها', desc: 'عرّف مجموعة برمز واسم؛ فعّلها أو أرشفها مع تطور الشرائح.' },
        { title: 'عيّن الأعضاء', desc: 'أضف أو أزل العملاء من مجموعة؛ يظهر العدد على المجموعة وعلى صفوف التسعير والقواعد المُحدَّدة بنطاق المجموعة.' },
        { title: 'اربطها بالتسعير', desc: 'في التسعير والقواعد، اختر نطاق الشريك = مجموعة على قاعدة Retail واختر هذه المجموعة — كل حجز مطابق لأعضائها يأخذ القاعدة.' },
      ],
    },
    examples: [
      {
        title: 'خصم مجموعة كبار العملاء على طبقة Retail',
        rows: [
          { label: 'المجموع الفرعي للمسافر (قبل قاعدة Retail)', value: '11,024,000' },
          { label: 'خصم Retail −3% · المجموعة = كبار العملاء', value: '−330,720', accent: 'success', strong: true },
          { label: 'يدفع عميل كبار العملاء', value: '10,693,280' },
        ],
        note: 'الحجز نفسه لعميل ليس من كبار العملاء يتخطى القاعدة ويدفع 11,024,000. عضوية المجموعة هي الشيء الوحيد المختلف.',
      },
      {
        title: 'رسم خدمة للعميل العابر — الاتجاه الآخر',
        rows: [
          { label: 'المجموع الفرعي للمسافر', value: '11,024,000' },
          { label: 'رسم خدمة Retail +150,000 · المجموعة = العملاء العابرون', value: '+150,000', accent: 'accent', strong: true },
          { label: 'يدفع العميل العابر', value: '11,174,000' },
        ],
        note: 'رسم خدمة ثابت يفرض إضافة على شريحة غير متحقق منها. القواعد الثابتة تتجاهل حجم السعر — كل حجز لعميل عابر يضيف نفس 150,000، أياً كان سعر التذكرة.',
      },
      {
        title: 'السعر الصافي المؤسسي — يمكن للمجموعة أيضاً أن تفتح صفقة متفاوَض عليها',
        rows: [
          { label: 'المجموع الفرعي القياسي للمسافر', value: '11,024,000' },
          { label: 'خصم Retail −6% · المجموعة = مؤسسي · Acme', value: '−661,440', accent: 'success', strong: true },
          { label: 'يدفع موظف Acme', value: '10,362,560' },
        ],
        note: 'خصم مجموعة أعمق يُرمّز عقداً مؤسسياً: كل من وُسِم ضمن «مؤسسي · Acme» يحصل تلقائياً على خصم Acme المتفاوَض عليه 6% — دون تجاوزات لكل حجز.',
      },
    ],
    related: ['customers', 'markup', 'agency-groups', 'loyalty'],
  },

  loyalty: {
    title: 'نادي الولاء',
    tag: 'مكافآت Voyager',
    tagline: 'برنامج نقاط الوكالة — كيف يكسب المسافرون النقاط ويصعدون المستويات ويستبدلونها.',
    business: {
      lead: 'نادي الولاء يحوّل المسافرين لمرة واحدة إلى مسافرين متكررين. يكسب العملاء النقاط أثناء الحجز، ويصعدون مستويات تفتح مزايا ومعدلات كسب أفضل، ويستبدلون النقاط مقابل حجوزات مستقبلية. الرصيد القائم التزام حقيقي تحمله الوكالة، لذا يُدار النادي بمعدلات كسب واستبدال صريحة.',
      points: [
        { title: 'الاحتفاظ بالعملاء بأرقام', desc: 'النقاط والمستويات تعطي العميل سبباً للحجز معك مجدداً بدلاً من منافس.' },
        { title: 'المستويات حسب الكسب التراكمي', desc: 'يعكس مستوى العميل النقاط المكتسبة تراكمياً، لذا لا يُخفّض الاستبدال مستواه أبداً — برونزي ← فضي ← ذهبي ← بلاتيني، لكل منها مضاعِف كسب أعلى.' },
        { title: 'النقاط التزام', desc: 'كل نقطة غير مستبدلة مال مستحق؛ نظرة النادي العامة تُظهر إجمالي النقاط والالتزام النقدي حتى يبقى مسجّلاً في الدفاتر.' },
      ],
    },
    software: {
      lead: 'نظرة عامة على النادي إضافة إلى الشيئين اللذين يشغّلانه: الإعدادات (المعدلات + المحفّز) وقواعد الكسب التلقائي.',
      points: [
        { title: 'مؤشرات النظرة العامة', desc: 'الأعضاء وإجمالي النقاط والالتزام والتوزيع لكل مستوى — محسوبة مباشرة من السجل.' },
        { title: 'إعدادات النادي', desc: 'حدد معدل الكسب ومعدل الاستبدال (نقاط لكل وحدة) وانتهاء صلاحية النقاط ومحفّز الكسب التلقائي — امنح عند الإصدار (تم التنفيذ) أو عند الدفع (تم تحصيل الدفع).' },
        { title: 'قواعد الكسب', desc: 'حرّر قواعد نقاط لكل منتج (مثلاً: الطيران يكسب 2× لكل وحدة)؛ إتمام الحجز يمنح النقاط من القاعدة المطابقة تلقائياً. الكسب/الاستبدال/التعديل لكل عميل موجود على كل ملف.' },
      ],
    },
    modes: {
      lead: 'يوجد مفهومان منفصلان للمستوى — لا تخلط بينهما.',
      modes: [
        { name: 'مستوى الولاء', when: 'مكتسب', desc: 'برونزي / فضي / ذهبي / بلاتيني، مشتق من النقاط المكتسبة تراكمياً. يحرّك مضاعِف الكسب والمزايا. لا يُضبط يدوياً أبداً.' },
        { name: 'مستوى كبار العملاء', when: 'يدوي', desc: 'علامة منفصلة يضبطها الوكيل على سجل العميل (قياسي / فضي / ذهبي / كبار العملاء) لمعالجة الخدمة — مستقلة عن نقاط الولاء.' },
      ],
    },
    examples: [
      {
        title: 'عتبات المستوى — تُحدَّد بالنقاط المكتسبة تراكمياً',
        rows: [
          { label: 'برونزي · 0+ مكتسب', value: '1× earn' },
          { label: 'فضي · 2,000+ مكتسب', value: '1.25× earn' },
          { label: 'ذهبي · 6,000+ مكتسب', value: '1.5× earn', accent: 'info' },
          { label: 'بلاتيني · 15,000+ مكتسب', value: '2× earn', accent: 'success' },
        ],
        note: 'يقرأ المستوى الكسب التراكمي، لذا إنفاق النقاط لا يخفّض مستوى العميل أبداً.',
      },
      {
        title: 'كسب تلقائي على حجز، وقفزة مستوى',
        rows: [
          { label: 'الكسب التراكمي قبل (فضي)', value: '5,600' },
          { label: 'قاعدة الطيران · 2 نقطة لكل وحدة × 250', value: '+500', accent: 'info', strong: true },
          { label: 'الكسب التراكمي بعد ← ذهبي', value: '6,100' },
        ],
        note: 'تُسجَّل النقاط تلقائياً عندما يبلغ الحجز محفّز الكسب في النادي (الإصدار أو الدفع). تجاوز 6,000 يرقّي العميل إلى ذهبي — كسب 1.5× من ذلك الحين.',
      },
      {
        title: 'استبدال النقاط (الافتراضي 100 نقطة = وحدة واحدة خصماً)',
        rows: [
          { label: 'رصيد النقاط', value: '8,000' },
          { label: 'استبدال 5,000 نقطة ← خصم', value: '−50', accent: 'success' },
          { label: 'الرصيد المتبقي', value: '3,000', strong: true },
        ],
        note: 'يُحدَّد معدل الاستبدال في إعدادات النادي؛ الرصيد نقاط قابلة للإنفاق، متمايزة عن الكسب التراكمي الذي يحدد المستوى.',
      },
      {
        title: 'التزام النادي — قيمة النقاط القائمة',
        rows: [
          { label: 'إجمالي النقاط غير المستبدلة عبر الأعضاء', value: '2,400,000' },
          { label: '÷ معدل الاستبدال (100 نقطة = 1)', value: '÷ 100' },
          { label: 'الالتزام النقدي في الدفاتر', value: '24,000', accent: 'accent', strong: true },
        ],
        note: 'تُظهر النظرة العامة هذا حتى لا يكون النادي كلفة خفية أبداً. رفع معدل الاستبدال (نقاط أكثر لكل وحدة) يخفّض الالتزام لكنه يجعل النقاط تكسب أقل للعميل — الرافعة للموازنة.',
      },
    ],
    related: ['customers', 'customer-groups', 'markup'],
  },

  agencies: {
    title: 'الوكالات',
    tag: 'الدليل',
    tagline: 'الدليل الرئيسي لشركات السفر B2B التي تتاجر على المنصة.',
    business: {
      lead: 'الوكالات هم عملاء المنصة من نوع B2B — شركات السفر التي تبيع لها المخزون. تحمل كل واحدة الشروط التجارية وشروط الامتثال التي تحكم كيفية تجارتها: مستواها، ومحفظتها أو خط ائتمانها، ووضع اعرف عميلك (KYC) الخاص بها.',
      points: [
        { title: 'المستويات تحدد الشروط', desc: 'مستوى الوكالة هو الرافعة وراء تسعيرها — يغذّي القواعد المُحدَّدة بنطاق المستوى في محرك التسعير والقواعد، حتى يمكن مكافأة الحجم بهامش أفضل.' },
        { title: 'المحفظة والائتمان هما حد التجارة', desc: 'تحجز الوكالة مقابل محفظة مدفوعة مسبقاً أو خط ائتمان معتمد؛ ذلك الرصيد هو ما يقيّد انكشاف المنصة.' },
        { title: 'اعرف عميلك يبوّب التجارة', desc: 'الوكالة الجديدة تنطلق فقط بعد اعتماد اعرف عميلك — عمود الحالة يُظهر، لكل صف، من يتاجر ومن محظور.' },
      ],
    },
    software: {
      lead: 'قائمة قابلة للبحث لكل وكالة، مع أعمدة التجارة والامتثال التي تحتاجها لإدارتها بلمحة.',
      points: [
        { title: 'امسح وصفِّ', desc: 'ابحث بالاسم أو جهة الاتصال أو الرمز وصفِّ حسب المستوى أو الحالة للعثور على من يهم.' },
        { title: 'اقرأ أعمدة الصحة', desc: 'رصيد المحفظة واستخدام الائتمان وحالة اعرف عميلك تظهر لكل صف.' },
        { title: 'افتح سجلاً', desc: 'انقر صفاً لفتح ملف الوكالة — حرّر شروطها وSIGNات وقنوات البيع والأدوار والوصول.' },
      ],
    },
    related: ['agency-profile', 'agents', 'agency-onboarding', 'markup'],
  },

  markup: {
    title: 'التسعير والقواعد',
    tag: 'محرك التسعير',
    tagline: 'حيث تُعرَّف كل طبقة من الهامش — من مالك SIGN إلى المُعيد بيعه إلى المسافر.',
    business: {
      lead: 'هكذا يُبنى السعر من السعر الصافي للمورّد وصولاً إلى ما يدفعه المسافر. المحرك مُطبَّق على طبقات: هامش Wholesale (مالك SIGN يفرض على مُعيد البيع)، ورسم Distribution (مالك القناة يفرض على الوكالة البائعة عبر قناته)، وهامش Retail (هامش الوكالة البائعة الخاص للعميل). كل طبقة مال طرف مختلف.',
      points: [
        { title: 'ثلاث طبقات، ثلاث علاقات', desc: 'Wholesale = مالك SIGN ← مُعيد البيع؛ Distribution = مالك القناة ← البائع؛ Retail = البائع ← المسافر. تنتمي القاعدة دائماً إلى طبقة واحدة بالضبط.' },
        { title: 'مُستهدَفة حسب الشريحة', desc: 'تضيق القواعد حسب المنتج أو المورّد أو شركة الطيران أو المسار أو الدرجة أو SIGN أو القناة أو مستوى الشريك أو مجموعته، أو وكالة شريكة محددة — حتى تسعّر بدقة.' },
        { title: 'الضوابط تحمي السعر', desc: 'الحدود الدنيا/القصوى والأولوية وحالة نشط/غير نشط تمنع قاعدة سيئة من جعل السعر غير تنافسي أو غير مربح.' },
      ],
    },
    software: {
      lead: 'محرك قواعد يُحلّ بحسب التحديد — القاعدة المطابقة الأكثر تحديداً تفوز ضمن كل طبقة.',
      points: [
        { title: 'ترتيب التحديد', desc: 'الشريك ← المستوى ← SIGN / القناة ← المسار ← افتراضي المالك. يسير المُحلّل عبر هذا السلّم لكل طبقة من الحجز.' },
        { title: 'التسجيل هو كيفية اختيار المُحلّل', desc: 'كل بُعد مطابقة غير عام تحدده القاعدة يساهم بوزن ثابت في نتيجتها. الفائز لكل طبقة = أعلى نتيجة. تعادل ← الأولوية `priority` الأعلى تفوز؛ ما زال تعادلاً ← القاعدة المُحدَّثة أحدث تفوز. يُظهر المحاكي النتيجة على كل بطاقة مرشّحة حتى ترى بالضبط لماذا تغلبت قاعدة على أخرى.' },
        { title: 'ابنِ القواعد وصفِّها', desc: 'حرّر طبقة القاعدة ونوع التعديل والقيمة (نسبة / ثابت / متدرّج) والأساس والنطاق؛ صفِّ القائمة المتنامية حسب النوع أو المنتج أو نطاق الشريك أو الحالة.' },
        { title: 'حاكِ قبل التفعيل', desc: 'المحاكي المدمج يسعّر حجزاً افتراضياً ويُظهر بالضبط أي قاعدة تُطلق لكل طبقة — دون أي خطر على التسعير الحي.' },
      ],
    },
    examples: [
      {
        title: 'أوزان التحديد — قيمة كل بُعد مطابقة',
        rows: [
          { label: 'الشريك = وكالة محددة', value: '100' },
          { label: 'SIGN (wholesale) · القناة (distribution)', value: '90' },
          { label: 'المنشأ والوجهة — مطار / محطة', value: '70' },
          { label: 'مجموعة الشريك', value: '60' },
          { label: 'المنشأ والوجهة — مدينة', value: '50' },
          { label: 'مستوى الشريك', value: '40' },
          { label: 'المنطقة', value: '35' },
          { label: 'المورّد · شركة الطيران · نوع السعر', value: '30 لكل واحد' },
          { label: 'الدرجة', value: '25' },
          { label: 'المنتج', value: '20' },
        ],
        note: 'نتيجة القاعدة هي مجموع أوزان كل بُعد غير عام طابق الحجز فعلياً. الأبعاد العامة (فارغة) لا تُسجَّل — إنها فقط لا تستبعد.',
      },
      {
        title: 'قاعدتان تتنافسان — أعلى نتيجة تفوز',
        rows: [
          { label: 'الحجز: البائع = Nomad (مستوى GOLD)، المنتج = طيران', value: '' },
          { label: 'القاعدة A · WHOLESALE · TIER=GOLD + المنتج=طيران', value: '40 + 20 = 60', accent: 'info' },
          { label: 'القاعدة B · WHOLESALE · AGENCY=Nomad', value: '100', accent: 'success' },
          { label: 'الفائز', value: 'القاعدة B', strong: true },
        ],
        note: 'كلتا القاعدتين تطابقان هذا الحجز. قفل الوكالة الشريكة للقاعدة B يسجّل 100 وحده — يتغلب على تركيبة المستوى+المنتج للقاعدة A (60). الشريك المحدد هو البُعد الأكثر تحديداً الذي يعرفه المحرك.',
      },
      {
        title: 'نفس النتيجة — الأولوية تفصل التعادل',
        rows: [
          { label: 'الحجز: المنتج=طيران، الدرجة=BUSINESS، المورّد=Amadeus', value: '' },
          { label: 'القاعدة X · المنتج+الدرجة (20+25) · الأولوية=0', value: 'النتيجة 45 · الأولوية 0' },
          { label: 'القاعدة Y · المنتج+المورّد (20+30) · الأولوية=10', value: 'النتيجة 50 · الأولوية 10', accent: 'success' },
          { label: 'الفائز', value: 'القاعدة Y (نتيجة أعلى)', strong: true },
        ],
        note: 'تفوز Y بالنتيجة الخام (50 > 45). إذا تعادلت قاعدتان يوماً في النتيجة، تفصلها الأولوية `priority` — وإذا تعادلت `priority` أيضاً، فإن القاعدة المُحدَّثة أحدث تفوز. ذلك الفاصل الأخير يعني أن تحرير قاعدة قائمة يُنعشها فعلياً إلى قمة مجموعة متعادلة لولا ذلك.',
      },
      {
        title: 'Wholesale — مالك SIGN ← مُعيد البيع (على السعر الصافي)',
        rows: [
          { label: 'صافي شركة الطيران', value: '10,000,000' },
          { label: 'MARKUP +4% من الصافي', value: '+400,000', accent: 'info' },
          { label: 'كلفة مُعيد البيع', value: '10,400,000', strong: true },
        ],
      },
      {
        title: 'Retail — البائع ← المسافر (على الإجمالي الجاري)',
        rows: [
          { label: 'المجموع الجاري', value: '10,400,000' },
          { label: 'MARKUP +6% من الإجمالي', value: '+624,000', accent: 'success' },
          { label: 'المجموع الفرعي للمسافر', value: '11,024,000', strong: true },
        ],
      },
      {
        title: 'Distribution — رسم القناة (إضافة مقابل مشاركة الإيراد)',
        rows: [
          { label: 'إضافة +2% على 11,024,000', value: '+220,480', accent: 'accent' },
          { label: 'مشاركة إيراد 2% (من الهامش)', value: 'price unchanged' },
        ],
        note: 'تُفرض الإضافة فوق السعر؛ مشاركة الإيراد تترك سعر المسافر كما هو وتخصم حصة القناة من هامش البائع.',
      },
      {
        title: 'أنماط القيمة — الأساس 10,000,000، حجز 3 مسافرين / مقطعين',
        rows: [
          { label: 'نسبة · 5% × 10,000,000', value: '500,000' },
          { label: 'ثابت · 150,000 لكل حجز', value: '150,000' },
          { label: 'ثابت · 150,000 لكل مسافر × 3', value: '450,000' },
          { label: 'ثابت · 150,000 لكل مقطع × 2', value: '300,000' },
          { label: 'نسبة + ثابت · 3% + 200,000', value: '500,000' },
        ],
        note: 'أي طبقة يمكنها استخدام أي نمط. نوع التعديل يحدد الإشارة: MARKUP / SERVICE_FEE يضيفان؛ DISCOUNT / REBATE يطرحان.',
      },
      {
        title: 'شلال من البداية للنهاية — الشريك يُصدر تحت SIGN، ثم يعيد البيع',
        rows: [
          { label: 'صافي المورّد (شركة الطيران)', value: '10,000,000' },
          { label: '+ Wholesale MARKUP 4%', value: '+400,000', accent: 'info' },
          { label: '+ Retail MARKUP 6%', value: '+624,000', accent: 'success' },
          { label: '+ Distribution إضافة 2%', value: '+220,480', accent: 'accent' },
          { label: 'سعر المسافر', value: '11,244,480', strong: true },
        ],
        note: 'بالضبط ما يحسبه المحاكي. مع مشاركة الإيراد بدلاً من الإضافة، لا يزال المسافر يدفع 11,024,000 وتأتي 220,480 للقناة من هامش البائع.',
      },
    ],
    related: ['agency-groups', 'sign-access', 'channel-access', 'agencies'],
  },

  'partner-access': {
    title: 'وصول الشركاء',
    tag: 'الاقتران',
    tagline: 'كيف تقترن الوكالات لتشارك بيانات الإصدار (SIGNات) وقنوات البيع.',
    business: {
      lead: 'ليست كل وكالة تملك بيانات اعتماد شركات الطيران (SIGNات) أو قنوات البيع التي تحتاجها لإصدار كل ما تستطيع بيعه. وصول الشركاء يتيح لوكالتين الاتصال ومشاركة تلك الأصول — بحيث يمكن لإحداهما الإصدار على SIGN الأخرى أو البيع عبر قناتها — موسّعاً ما تستطيع كلتاهما بيعه دون شراء أي منهما مخزوناً جديداً.',
      points: [
        { title: 'استعِر المدى واحتفظ بالسيطرة', desc: 'يمنح المالك الوصول ويمكنه إلغاؤه في أي وقت — المشاركة إذن، لا نقل للأصل.' },
        { title: 'يجب أن يوافق الطرفان', desc: 'الاقتران وكل منحة هما موافقة ثنائية: عرض أو طلب يقبله الطرف الآخر قبل مشاركة أي أصل.' },
        { title: 'اتجاهان للقيمة', desc: 'تتتبع ما تشاركه إلى الشركاء وما تستخدمه منهم بوصفهما سجلين منفصلين.' },
      ],
    },
    software: {
      lead: 'تدير هذه الشاشة الاقترانات ومنح SIGN / قناة البيع التي تتدفق عبرها.',
      points: [
        { title: 'اتصل برمز الوكالة', desc: 'أرسل طلب شراكة باستخدام رمز الوكالة الفريد للشريك؛ يقبلونه أو يرفضونه.' },
        { title: 'امنح SIGNات وقنوات البيع', desc: 'اعرض SIGN (بيانات إصدار شركة طيران) أو قناة بيع لشريك، مُحدَّدة النطاق ومحدودة الزمن؛ يقبلها المُمنَح لتفعيلها.' },
        { title: 'أدِر السجلين', desc: 'راجع الوصول الذي منحته والوصول الذي تلقيته، وألغِه عند انتهاء العلاقة.' },
      ],
    },
    examples: [
      {
        title: 'تشارك SIGN — تكسب هامش Wholesale على كل تذكرة شريك',
        rows: [
          { label: 'الشريك يُصدر تذكرة EK · صافي شركة الطيران', value: '10,000,000' },
          { label: 'هامش Wholesale الخاص بك 4% (يدفعون لك)', value: '+400,000', accent: 'info', strong: true },
          { label: 'كلفة الشريك للتذكرة', value: '10,400,000' },
        ],
        note: 'أنت لا تلمس الحجز أبداً — مشاركة SIGN الخاص بك تكسبك 400,000 لكل تذكرة يُصدرها الشريك تحته. يحتفظون بأي هامش تجزئة يضيفونه لعميلهم الخاص.',
      },
      {
        title: 'تستخدم SIGN شريك — ادفع Wholesale الخاص به، احتفظ بـ Retail الخاص بك',
        rows: [
          { label: 'تُصدر تذكرة EK على SIGN الخاص بهم · صافي', value: '10,000,000' },
          { label: '+ هامش Wholesale الخاص بهم 4% ← كلفتك', value: '10,400,000' },
          { label: '+ هامش Retail الخاص بك 6% لعميلك', value: '+624,000', accent: 'success' },
          { label: 'يدفع عميلك', value: '11,024,000', strong: true },
        ],
        note: 'استعارة SIGN تتيح لك بيع شركة طيران لا تملكها. تدفع هامش Wholesale الخاص بالمالك وتحتفظ بهامش Retail الخاص بك 624,000.',
      },
      {
        title: 'تشارك قناة بيع — مشاركة إيراد مقابل إضافة',
        rows: [
          { label: 'الشريك يبيع سعر 10,000,000 عبر قناتك', value: '10,000,000' },
          { label: 'مشاركة إيراد 2% (حصتك، من هامشهم)', value: '+200,000', accent: 'accent', strong: true },
          { label: 'إضافة 2% (تُفرض فوق ← يدفعها المسافر)', value: '10,200,000' },
        ],
        note: 'مشاركة الإيراد تكسبك 200,000 من هامش البائع مع بقاء سعر المسافر كما هو؛ الإضافة تضيف رسمك فوق السعر. تحدد أيهما، لكل منحة.',
      },
    ],
    related: ['sign-access', 'channel-access', 'signs', 'sale-channels'],
  },

  agents: {
    title: 'الوكالات الفرعية',
    tag: 'خط النزول',
    tagline: 'المُعيدون بيعهم الذين يقعون تحت وكالة رئيسية ويبيعون نيابة عنها.',
    business: {
      lead: 'الوكالات الفرعية توسّع التوزيع دون أن تُدخِل المنصة الجميع مباشرة. تجنّد الوكالة الرئيسية هؤلاء، وتحدد شروطهم التجارية، وتقف خلف تجارتهم — محوّلةً علاقة واحدة إلى سلسلة بيع.',
      points: [
        { title: 'مدى دون عبء', desc: 'كل وكالة فرعية نقطة بيع جديدة لم تكن المنصة مضطرة لتسجيلها أو تمويلها فردياً.' },
        { title: 'الهامش مُطبَّق على طبقات', desc: 'يمكن للوكالة الرئيسية إضافة هامش Retail الخاص بها فوق سعر المنصة قبل أن ترى الوكالة الفرعية أي سعر — ذلك الفرق هو عملها.' },
        { title: 'مساءلة موحّدة', desc: 'المحفظة والائتمان والتسوية تتجمع صعوداً للأصل، لذا تسوّي المنصة مع طرف مقابل واحد.' },
      ],
    },
    software: {
      lead: 'يسرد كل من يتبع وكالة، مع الضوابط التي تحكم ما يستطيع كل منها فعله.',
      points: [
        { title: 'إعداد لكل وكالة', desc: 'تجاوزات الهامش والمنتجات المسموحة والوصول تُضبط على كل وكالة فرعية من سجلها.' },
        { title: 'مجاميع التجميع صعوداً', desc: 'الحجوزات والإيرادات من خط النزول تتجمع صعوداً للأصل ولإجمالي الشبكة.' },
        { title: 'عرض المشرف مقابل عرض الوكالة', desc: 'يرى المشرفون الشبكة كاملة؛ الوكالة المسجّلة دخولها ترى خط نزولها فقط.' },
      ],
    },
    related: ['agencies', 'markup', 'partner-access'],
  },

  companies: {
    title: 'الشركات',
    tag: 'الأصل المؤسسي',
    tagline: 'الكيانات القانونية التي تملك قنوات البيع وتجمع الوكالات تحت سقف واحد.',
    business: {
      lead: 'الشركة هي الأصل المؤسسي فوق الوكالات — الكيان الذي يمكنه امتلاك قنوات البيع وبالتالي كسب رسوم طبقة Distribution. تجميع العلامات أو الوكالات تحت شركة واحدة يبقي ملكية الأصول التجارية المشتركة والتسوية في مكان واحد.',
      points: [
        { title: 'تملك أصول التوزيع', desc: 'تحمل الشركات قنوات البيع (لا SIGNات)؛ قواعد Distribution للشركة تسعّر ما يتدفق عبر تلك القنوات.' },
        { title: 'طرف مقابل قانوني واحد', desc: 'يمكن لعدة وكالات أو علامات أن تقع تحت شركة واحدة للتعاقد والتسوية.' },
        { title: 'فصل المسؤوليات', desc: 'إصدار شركات الطيران (SIGNات) يعيش مع الوكالات؛ توزيع القنوات يعيش مع الشركة.' },
      ],
    },
    software: {
      lead: 'دليل الشركات والقنوات التي تملكها.',
      points: [
        { title: 'أدِر سجلات الشركات', desc: 'أنشئ وحرّر الشركات وشاهد الوكالات والقنوات المرتبطة بكل منها.' },
        { title: 'ملكية القناة', desc: 'قنوات البيع للشركة تُدار من قنوات البيع وتُسعَّر من التسعير والقواعد (طبقة Distribution).' },
        { title: 'النطاق في المُنتقيات', desc: 'يظهر مالكو الشركات في مُنتقي المالك في التسعير والقواعد بوصفهم «قنوات فقط».' },
      ],
    },
    related: ['sale-channels', 'channel-access', 'agencies'],
  },

  'sale-channels': {
    title: 'قنوات البيع',
    tag: 'التوزيع',
    tagline: 'الواجهات والقنوات التي يُباع المخزون عبرها.',
    business: {
      lead: 'قناة البيع هي طريق إلى السوق — موقع إلكتروني أو تطبيق أو تكامل API أو مكتب دون اتصال — تملكها وكالة أو شركة. إنها الأصل الذي تفرض عليه طبقة Distribution: من يملك القناة يمكنه أخذ رسم أو مشاركة إيراد على ما يُباع عبرها.',
      points: [
        { title: 'القناة نقطة إيراد', desc: 'المبيعات المتدفقة عبر قناة يمكن أن تحمل رسم Distribution أو مشاركة إيراد لمالك القناة.' },
        { title: 'امتلك أو استعِر', desc: 'تبيع عبر قنواتك الخاصة، أو عبر قناة شريك عن طريق منحة وصول القناة.' },
        { title: 'شكّل التقسيم', desc: 'رسم القناة يمكن أن يكون إضافة (فوق السعر) أو مشاركة إيراد (من هامش البائع).' },
      ],
    },
    software: {
      lead: 'دليل قنوات البيع مع مالكها وشكل تسويتها.',
      points: [
        { title: 'أنشئ وأعِدّ', desc: 'سجّل قناة، حدد مالكها (وكالة أو شركة) ومشاركة الإيراد / الشكل الافتراضي لها.' },
        { title: 'امنح للشركاء', desc: 'شارك قناة عبر وصول القناة حتى تتمكن وكالة شريكة من البيع عبرها.' },
        { title: 'تغذّي التسعير', desc: 'قواعد Distribution في التسعير والقواعد تستهدف قناة محددة أو كلها.' },
      ],
    },
    related: ['channel-access', 'companies', 'partner-access', 'markup'],
  },

  'channel-access': {
    title: 'وصول القناة',
    tag: 'منحة التوزيع',
    tagline: 'السماح لوكالة شريكة بالبيع عبر قناة بيعك.',
    business: {
      lead: 'وصول القناة هو كيفية إعارة قناة بيع لوكالة أخرى. يمنح المالك شريكاً الحق في البيع عبر قناته — عادة مقابل مشاركة إيراد — موسّعاً التوزيع دون تسليم الأصل. هذه هي المنحة الدقيقة وراء طبقة تسعير Distribution.',
      points: [
        { title: 'مدى، على مشاركة إيراد', desc: 'يبيع المُمنَح عبر القناة؛ يحتفظ المالك بحصة من الإجمالي المتدفق عبرها.' },
        { title: 'موافقة ثنائية', desc: 'المنحة تُعرض وتُقبَل — لا يُشارك شيء حتى يوافق الطرفان — ويمكن إلغاؤها في أي وقت.' },
        { title: 'تحرّك قواعد Distribution', desc: 'مشاركة إيراد المنحة هي الاحتياطي القديم؛ قواعد Distribution الصريحة في التسعير والقواعد تتجاوزها.' },
      ],
    },
    software: {
      lead: 'سجل منح القنوات — المُعطاة والمُتلقاة.',
      points: [
        { title: 'امنح وحدد النطاق', desc: 'اعرض قناة لشريك بمشاركة إيراد وشكل ونافذة صلاحية اختيارية.' },
        { title: 'اقبل / ارفض', desc: 'يقبل المُمنَح لتفعيل الوصول، أو يرفضه.' },
        { title: 'ألغِ', desc: 'أنهِ الوصول عند انتهاء العلاقة؛ الحجوزات الجارية تُسوّى على الشروط السارية.' },
      ],
    },
    related: ['sale-channels', 'partner-access', 'markup', 'companies'],
  },

  'sign-access': {
    title: 'وصول SIGN',
    tag: 'منحة Wholesale',
    tagline: 'السماح لوكالة شريكة بإصدار التذاكر تحت SIGN الخاص بك.',
    business: {
      lead: 'وصول SIGN يُعير بيانات إصدار (SIGN) لوكالة أخرى حتى تتمكن من إصدار تذاكر مورّد لا تملك بيانات اعتماده. يمنح مالك SIGN الوصول، ويحدد هامشاً تجاه ذلك المُمنَح، ويمكنه إلغاؤه — هذه هي المنحة وراء طبقة تسعير Wholesale.',
      points: [
        { title: 'أصدر على بيانات مستعارة', desc: 'يُصدر المُمنَح التذاكر تحت SIGN الخاص بالمالك دون تسجيل بيانات BSP/IATA الخاصة به.' },
        { title: 'هامش تجاه المُمنَح', desc: 'يحدد المالك هامش Wholesale لكل منحة — هامشه مقابل إعارة SIGN.' },
        { title: 'موافقة ثنائية', desc: 'المنحة تُعرض وتُقبَل، ويمكن إلغاؤها؛ المشاركة إذن، لا نقل.' },
      ],
    },
    software: {
      lead: 'سجل منح SIGN — المُعطاة والمُتلقاة.',
      points: [
        { title: 'امنح وحدد الهامش', desc: 'اعرض SIGN لشريك مع تجاوز هامش اختياري ونافذة صلاحية.' },
        { title: 'اقبل / ارفض', desc: 'يقبل المُمنَح لبدء الإصدار على SIGN، أو يرفض.' },
        { title: 'تغذّي قواعد Wholesale', desc: 'هامش المنحة هو الاحتياطي القديم؛ قواعد Wholesale الصريحة في التسعير والقواعد (نطاق AGENCY / SIGN) تتجاوزه.' },
      ],
    },
    related: ['signs', 'partner-access', 'markup', 'agencies'],
  },

  signs: {
    title: 'SIGNات',
    tag: 'بيانات الإصدار',
    tagline: 'بيانات اعتماد BSP / IATA / CASS التي تستخدمها الوكالة لإصدار التذاكر.',
    business: {
      lead: 'SIGN هو بيان الاعتماد المُسجَّل الذي يتيح للوكالة إصدار التذاكر مقابل مورّد محدد. إنه الأصل في قلب طبقة Wholesale: يمكن لمالك SIGN الإصدار مباشرة، أو إعارة SIGN للشركاء (وصول SIGN) وإضافة هامش على ما يُصدرونه.',
      points: [
        { title: 'الحق في الإصدار', desc: 'بدون SIGN — أو وصول مستعار إلى واحد — يمكن للوكالة البيع لكن ليس الإصدار مقابل ذلك المورّد.' },
        { title: 'واحد نشط لكل مورّد', desc: 'تحمل الوكالة SIGN نشطاً واحداً لكل مورّد؛ المُستبدَلة تُتقاعَد، لا تُحذف.' },
        { title: 'أصل Wholesale', desc: 'إعارة SIGN وإضافة هامش على إصدار المُمنَح هي عمل طبقة Wholesale.' },
      ],
    },
    software: {
      lead: 'سجل SIGNات الوكالة، مع مورّدها ورمزها ومُصدِرها وصلاحيتها.',
      points: [
        { title: 'سجّل SIGN', desc: 'سجّل المورّد ورمز SIGN والمُصدِر وحساب BSP مع نافذة صلاحية.' },
        { title: 'مملوكة لوكالة', desc: 'SIGNات مملوكة دائماً لوكالة (الشركات تملك القنوات، لا SIGNات).' },
        { title: 'شارك عبر وصول SIGN', desc: 'أعِر SIGN لشريك من وصول SIGN؛ ألغِه عند انتهاء العلاقة.' },
      ],
    },
    related: ['sign-access', 'partner-access', 'markup', 'agencies'],
  },

  branches: {
    title: 'الفروع',
    tag: 'الهيكل التنظيمي',
    tagline: 'المكاتب الفرعية للوكالة، تُستخدم لتحديد نطاق الموظفين والحجوزات.',
    business: {
      lead: 'الفروع تُنمذج المكاتب الفرعية المادية أو التنظيمية للوكالة. تتيح لوكالة أكبر تنظيم أفرادها ونسب الحجوزات والأداء إلى المكتب الذي أنجزها، دون التقسيم إلى وكالات منفصلة.',
      points: [
        { title: 'النسب', desc: 'يمكن التبليغ عن الحجوزات والإيرادات لكل فرع، فترى أي مكتب يؤدي.' },
        { title: 'تحديد نطاق الموظفين', desc: 'يُسنَد المستخدمون إلى فرع، مبقيةً عرضهم وصلاحياتهم ضمن مكتبهم.' },
        { title: 'وكالة واحدة، مكاتب عدة', desc: 'الفروع تبقي وكالة متعددة المكاتب علاقة تجارية واحدة.' },
      ],
    },
    software: {
      lead: 'دليل فروع الوكالة.',
      points: [
        { title: 'أنشئ وحرّر', desc: 'أضف الفروع مع اسمها وجهة اتصالها وتفاصيل موقعها.' },
        { title: 'أسنِد الموظفين', desc: 'يُستخدم الفرع عند تزويد المستخدمين والأدوار تحت الوكالة.' },
        { title: 'عرض المشرف مقابل عرض الوكالة', desc: 'يدير المشرف فروع أي وكالة؛ الوكالة تدير فروعها الخاصة.' },
      ],
    },
    related: ['agencies', 'agency-profile'],
  },

  'agency-groups': {
    title: 'مجموعات الوكالات',
    tag: 'التقسيم إلى شرائح',
    tagline: 'حِزَم مُسمّاة من الوكالات يمكنك استهدافها بقاعدة تسعير واحدة.',
    business: {
      lead: 'مجموعات الوكالات هي حِزَم تقسيم إلى شرائح — «متخصصو العمرة»، «مؤسسي طهران» — تتيح لك تسعير مجموعة كاملة من الوكالات معاً بدلاً من واحدة تلو الأخرى. تشغّل نطاق شريك GROUP في محرك التسعير.',
      points: [
        { title: 'سعّر حسب الشريحة', desc: 'المجموعة هدف لقاعدة تسعير في التسعير والقواعد بنطاق شريك = مجموعة.' },
        { title: 'العضوية متعددة لمتعددة', desc: 'يمكن للوكالة أن تنتمي إلى عدة مجموعات؛ والمجموعة تحمل وكالات كثيرة.' },
        { title: 'مُحدَّدة بنطاق المالك', desc: 'المجموعة إما مشتركة على مستوى المنصة أو مملوكة لوكالة، وتتبع دورة حياة حالة (لا تُحذف نهائياً أبداً).' },
      ],
    },
    software: {
      lead: 'واجهة إدارة المجموعات وعضوياتها.',
      points: [
        { title: 'أنشئ ونسّق', desc: 'عرّف مجموعة وأضف أو أزل الوكالات الأعضاء.' },
        { title: 'استهدف في التسعير', desc: 'تظهر المجموعة في مُنتقي نطاق شريك المجموعة في محرر القواعد.' },
        { title: 'دورة حياة، لا حذف', desc: 'أحِل المجموعة إلى التقاعد بالحالة حتى تبقى القواعد القائمة التي تشير إليها قابلة للحل.' },
      ],
    },
    related: ['markup', 'agencies'],
  },
};
